
export default {
  props: {
    showModal: {
      type: Boolean
    },
    sentText: {
      type: String,
      default: 'Thank you for getting in touch! One of our Customer Happiness members will be getting back to you within a few hours.'
    }
  },
  data () {
    return {

    }
  }
}
